import { configureStore } from "@reduxjs/toolkit";
import todoApp from "../reducers/reducers";

const store = configureStore({
  reducer: todoApp,
});

export type RootState = ReturnType<typeof store.getState>;
export default store;
